<template>
    <div class="userTop">
        <p>账户统计信息</p>
        <el-row :gutter="20">
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="消费总金额"></el-statistic>
                </div>
            </el-col>
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="退款总金额"></el-statistic>
                </div>
            </el-col>
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="消费次数"></el-statistic>
                </div>
            </el-col>
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="客单价"></el-statistic>
                </div>
            </el-col>
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="购买项目总数"></el-statistic>
                </div>
            </el-col>
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="滑扣项目总数"></el-statistic>
                </div>
            </el-col>
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="剩余项目总数"></el-statistic>
                </div>
            </el-col>
            <el-col :span="3">
                <div>
                    <el-statistic group-separator="," :precision="2" :value="userstatic.value2" title="预约数"></el-statistic>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: ['userstatic'],
    data() {
        return {}
    }
}
</script>
<style scoped>
.like {
  cursor: pointer;
  font-size: 25px;
  display: inline-block;
}
.userTop {
  border: 1px solid #666363;
  margin-top: 10px;
}
</style>

